export default function personsoccupationslist() {
  const list = [
    { label: 'Actor', value: 'Actor' },
    { label: 'Editor', value: 'Editor' },
    { label: 'Director', value: 'Director' },
    { label: 'Producer', value: 'Producer' },
    { label: 'Writer', value: 'Writer' },
    { label: 'World music', value: 'World music' },
    { label: 'Screenwriter', value: 'Screenwriter' },
    { label: 'Film director', value: 'Film director' },
    { label: 'Record producerfilm', value: 'Record producerfilm' },
    { label: 'Composersinger', value: 'Composersinger' },
    { label: 'Songwriter', value: 'Songwriter' },
    { label: 'Film editor', value: 'Film editor' },
    { label: 'Comedy writer', value: 'Comedy writer' },
    { label: 'Cinematographer', value: 'Cinematographer' },
    { label: 'Film Producer', value: 'Film Producer' },
    { label: 'Comedian', value: 'Comedian' },
    { label: 'Television host', value: 'Television host' },
    { label: 'Model', value: 'Model' },
    { label: 'Motivational speaker', value: 'Motivational speaker' },
    { label: 'Choreographer', value: 'Choreographer' },
    { label: 'Sub Inspector', value: 'Sub Inspector' },
    { label: 'Music director', value: 'Music director' },
    { label: 'Singer', value: 'Singer' },
    { label: 'Dancer', value: 'Dancer' },
    { label: 'Lawyer', value: 'Lawyer' },
    { label: 'Social Activist', value: 'Social Activist' },
    { label: 'lyricist', value: 'lyricist' },
    { label: 'Author', value: 'Author' },
    { label: 'Music composers', value: 'Music composers' },
    { label: 'Music producers', value: 'Music producers' },
    { label: 'Judges', value: 'Judges' },
    { label: 'Former physician', value: 'Former physician' },
    { label: 'Theatre Artist', value: 'Theatre Artist' },
    { label: 'Corporate Leader', value: 'Corporate Leader' },
    { label: 'Mentor', value: 'Mentor' },
    { label: 'Television presenter', value: 'Television presenter' },
    { label: 'Novelist', value: 'Novelist' },
    { label: 'Playwright', value: 'Playwright' },
    { label: 'Musician', value: 'Musician' },
    { label: 'Chairman', value: 'Chairman' },
    { label: 'Dialogue writer', value: 'Dialogue writer' },
    { label: 'Ad director', value: 'Ad director' },
    { label: 'Film producer', value: 'Film producer' },
    { label: 'Animal welfare activist', value: 'Animal welfare activist' },
    { label: 'Film scorer', value: 'Film scorer' },
    { label: 'Composer', value: 'Composer' },
    { label: 'Sound designer', value: 'Sound designer' },
    { label: 'Sound editor', value: 'Sound editor' },
    { label: 'Production sound mixer', value: 'Production sound mixer' },
    { label: 'Lyricist', value: 'Lyricist' },
    { label: 'Child actress', value: 'Child actress' },
    { label: 'Lifecoach', value: 'Lifecoach' },
    { label: 'Playback singer', value: 'Playback singer' },
    { label: 'Fashion designer', value: 'Fashion designer' },
    { label: 'Entrepreneur', value: 'Entrepreneur' },
    { label: 'Motivational Speaker', value: 'Motivational Speaker' },
    { label: 'Radio Jockey', value: 'Radio Jockey' },
    { label: 'Television Show Host', value: 'Television Show Host' },
    { label: 'Columnist', value: 'Columnist' },
    { label: 'Television Personality', value: 'Television Personality' },
    { label: 'Director of photography', value: 'Director of photography' },
    { label: 'Politician', value: 'Politician' },
    { label: 'Film scholar', value: 'Film scholar' },
    { label: 'Cultural theorist', value: 'Cultural theorist' },
    { label: 'Track and field athlete', value: 'Track and field athlete' },
    { label: 'Actress', value: 'Actress' },
    { label: 'Communist leader', value: 'Communist leader' },
    { label: 'Rapper', value: 'Rapper' },
    { label: 'Film critic', value: 'Film critic' },
    { label: 'Tahsildar', value: 'Tahsildar' },
    { label: 'Civil engineer', value: 'Civil engineer' },
    { label: 'Instrumentalist', value: 'Instrumentalist' },
    { label: 'Arranger', value: 'Arranger' },
    { label: 'Programmer', value: 'Programmer' },
  ]
  return list
}
